<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xi">JUDAISM <span class="small">AND THE</span> WEST</a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Fm02.vue?65ed5a84